import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { filter, take, tap, map } from 'rxjs';

import { select, Store } from '@ngrx/store';
import { ApplicationState } from '../../store/application-store';
import * as tenancyScheduleTableActions from '@tenancy-schedule/actions/tenancy-schedule-table-columns';
import { IColumnDefinition } from '@common/models/column-definition';
import { getDefaultWidgetConfigAdminForm, addColumnFieldsToAdminForm } from '@feature/widget-admin/services/widget-admin-form';
import { WidgetConfiguration, WidgetConfigurationsService } from '@feature/widget-configs';
import { WidgetAdminHandler } from '@widget-admin/services/widget-admin-handler';
import { FormDefinition  } from '@feature/_app_modules/dynamic-forms/dynamic-form';
import { mapWherePropertiesMatch } from '@common/index';

@Injectable({
  providedIn: 'root'
})
export class TenancyScheduleWidgetAdminHandler implements WidgetAdminHandler {

  private availableColumnDefinitions: IColumnDefinition[];

  constructor(
    private readonly widgetConfigService: WidgetConfigurationsService,
    private readonly store: Store<ApplicationState>,
    ) { }

  initialise(): Observable<boolean> {

    this.store.dispatch(new tenancyScheduleTableActions.LoadAll());

    const columnConfig = this.store.pipe(
      select((state) => state.tenancyScheduleAvailableColumns.availableColumns),
      filter( (s)=> s != undefined ),
      tap((columnDefs) => {
        this.availableColumnDefinitions = columnDefs;
      }),
      take(1)
    );

    return columnConfig.pipe(map(r => true));

  }

  getAdminForm(selectedConfig: WidgetConfiguration): FormDefinition {

    let formDefinition = getDefaultWidgetConfigAdminForm(selectedConfig);

    formDefinition = addColumnFieldsToAdminForm(selectedConfig, this.availableColumnDefinitions, formDefinition);

    return formDefinition;

  }

  createCopyFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);

    return this.widgetConfigService.createcopy(copyOfSelectedConfig).pipe(
      map(r => true)
    );

  }

  saveConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {

    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);

    return this.widgetConfigService.save(copyOfSelectedConfig).pipe(
      map(r => true)
    );

  }

  deleteConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);

    return this.widgetConfigService.delete(copyOfSelectedConfig).pipe(
      map(r => true)
    );

  }

}



